/*
 * @Description: 数据字典
 * @Author: wangwangwang
 * @Date: 2020-06-30 14:18:14
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-14 15:32:09
 */
import request from '@/utils/request'
export const Download = "/base/system/base/dictionary/export";

// 获取数据字典
export function getDictionaryData(params) {
  return request({
    url: '/base/system/base/dictionary/query_page',
    method: 'post',
    data: params
  })
}
// 新增、编辑数据字典
export function editDictionary(params) {
  return request({
    url: '/base/system/base/dictionary/save_or_update',
    method: 'post',
    data: params
  })
}
// 根据字典ID获取字典详情
export function getDetail(params) {
  return request({
    url: '/base/system/base/dictionary/get_detail',
    method: 'get',
    params,
  })
}
// 修改数据状态
export function updateOrDelete(params) {
  return request({
    url: '/base/system/base/dictionary/update_or_delete',
    method: 'post',
    data: params,
  })
}
// 字典成员启用禁用
export function handleChild(params) {
  return request({
    url: '/base/system/base/dictionary/item/update_or_delete',
    method: 'post',
    data: params,
  })
}

// 字典成员启用禁用
export function updateSortnum(params) {
  return request({
    url: '/base/system/base/dictionary/update_sort_num',
    method: 'post',
    data: params,
  })
}
